export default "__VITE_ASSET__B2neNHhy__"